import * as types from '@/store/mutation-types'
export default {
    namespaced: true,
    state: {
        pricesTypes: []
    },

    actions: {
        // fetchAll
        fetchAll ({ commit }) {
            return window.axios.get('/price').then(({ data }) => {
                commit(types.STORE_PRICES, data)
                return data
            })
        },

        create ({ commit }, { name }) {
            return window.axios.post('/price', name, { headers: { 'Content-Type': 'application/json' } }).then(({ data }) => {
                return data
            })
        },

        update ({ commit }, { id, name }) {
            return window.axios.put(`/price/${id}`, name, { headers: { 'Content-Type': 'application/json' } }).then(({ data }) => {
                return data
            })
        },

        delete ({ commit }, { id }) {
            return window.axios.delete(`/price/${id}`)
        }
    },

    mutations: {
        [types.STORE_PRICES] (state, pricesTypes) {
            state.pricesTypes = pricesTypes
        }
    },

    getters: {
        getPriceTypeById: state => id => state.pricesTypes.find(c => c.id === id)
    }
}